import { combineReducers } from 'redux';
import user from './user';
import feedback from './feedback';
import gameState from './gameState';
import project from './project';
import group from './group';
import schoolClass from './schoolClass';
import gameStateInput from './gameStateInput';
import popupState from './popup';
import policyChoice from './policyChoice';
import timer from './timer';

export default combineReducers({
  feedback,
  user,
  gameState,
  project,
  group,
  schoolClass,
  popupState,
  gameStateInput,
  policyChoice,
  timer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js